import React from 'react';
import GlobalHelper from '../../Helpers/GlobalHelper';

const DateMask = (props) => {

    function convertDate() {
        return props.fecha ? GlobalHelper.FormatDate(props.fecha.slice(0, 19).replace('T', ' ')) : "-";
    }

    return (
        <span>{convertDate()}</span>
    );
}

export default DateMask;